import React from 'react';
import { useDispatch } from 'react-redux';
import {Button} from 'reactstrap';
import { toggleFontModal } from '../../../../../slices/modals/reducer';

function FontBtn() {
  const dispatch = useDispatch();
  function openFonts() {
    dispatch(toggleFontModal());
  }
  return (
    <button className='btn btn-ghost-gray' onClick={openFonts}>
      <i className='mdi mdi-format-font me-2 align-middle'></i>
      Manage Fonts
    </button>
  )
}

export default FontBtn
